import React, { useState } from 'react';
import { LinkText, Paragraph } from '@sb1/ffe-core-react';
import { txt } from './i18n/texts';
import { InputGroup, TextArea, Checkbox } from '@sb1/ffe-form-react';
import { ActionButton, ButtonGroup, TertiaryButton, } from '@sb1/ffe-buttons-react';
export var FeedbackExpanded = function (_a) {
    var _b;
    var locale = _a.locale, handleFeedback = _a.handleFeedback, contactLink = _a.contactLink, _c = _a.includeConsent, includeConsent = _c === void 0 ? false : _c;
    var _d = useState(), feedbackText = _d[0], setFeedbackText = _d[1];
    var _e = useState(false), consentGiven = _e[0], setConsentGiven = _e[1];
    var contactLinkElement = contactLink ? (React.createElement(LinkText, { href: contactLink.url, className: "ffe-feedback__link-button", onClick: contactLink === null || contactLink === void 0 ? void 0 : contactLink.onClick }, (_b = contactLink.linkText) !== null && _b !== void 0 ? _b : txt[locale].FEEDBACK_LINK_TEXT)) : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Paragraph, null,
            txt[locale].FEEDBACK_ANSWER,
            contactLinkElement && txt[locale].QUESTIONS,
            contactLinkElement),
        React.createElement(InputGroup, { className: "ffe-feedback__textarea-container", label: txt[locale].FEEDBACK_IMPROVE, description: txt[locale].FEEDBACK_SENSITIVE },
            React.createElement(TextArea, { "data-testid": "feedbackTextArea", onChange: function (event) { return setFeedbackText(event.target.value); }, value: feedbackText, rows: 6, maxLength: 1000, className: "ffe-feedback__textarea" })),
        includeConsent && (React.createElement("div", { className: "ffe-feedback__consent" },
            React.createElement(Checkbox, { checked: consentGiven, onChange: function (event) {
                    return setConsentGiven(event.target.checked);
                } }, txt[locale].FEEDBACK_CONSENT))),
        React.createElement(ButtonGroup, { className: "ffe-feedback__button-group", ariaLabel: txt[locale].FEEDBACK_BUTTON_GROUP, thin: true },
            React.createElement(ActionButton, { onClick: function () {
                    if (feedbackText) {
                        handleFeedback(feedbackText, includeConsent ? consentGiven : undefined);
                    }
                } }, txt[locale].FEEDBACK_BUTTON_SEND),
            React.createElement(TertiaryButton, { onClick: function () { return handleFeedback(); } }, txt[locale].FEEDBACK_BUTTON_CANCEL))));
};
